<label class="switch switch-disabled" [style.scale]="scale">
	<input type="checkbox" *ngIf="!locked" [formControl]="toggleInput" [disabled]="toggleInput.disabled">
	<span
		class="slider round flex-center"
		[ngClass]="{ 'toggle-disabled': toggleInput.disabled || locked }"
	>
    <span class="knob" [ngClass]="{ 'locked': locked || toggleInput.disabled, 'unlocked': !locked }"></span>
  </span>
</label>
